import { Alert, Grid } from '@mui/material'
import React from 'react'

import { CustomLoading } from 'common';

export const Totals = ({ useFetchInit }) => {

    const { FetchData } = useFetchInit
    const { fetchServiceTotal } = FetchData
    const { loadingFetchTotals, dataTotals } = fetchServiceTotal

    return (
        <>
            {loadingFetchTotals && <CustomLoading />}

            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                {dataTotals?.map((item, index) => (
                    <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
                        <Alert severity={item.tipo === 'RETIRADOS' ? 'success' : 'info'}>
                            <h5>
                                {item.total} {item.tipo}
                            </h5>

                            <span>
                                <strong>último recuento:</strong> {item.fecha}
                            </span>
                        </Alert>
                    </Grid>
                ))}
            </Grid>
        </>
    )
}